'use client';

// The shared boundary must render inside this document; see `src/components/route-error.tsx`.
export { default } from '@/components/route-error';
